import { useQuery } from '@tanstack/react-query'
import { sponsorsApi } from '../api/sponsors'
import { Sponsor } from '../types/sponsor'

export const useSponsors = (eventSlug: string) => {
    return useQuery<Sponsor[]>({
        queryKey: ['sponsors', eventSlug],
        queryFn: () => sponsorsApi.getSponsors(eventSlug),
        staleTime: 10 * 60 * 1000, // 10 minutes
    })
}